import type { AuthorizeResult } from './connectors';

export interface ConnectRefusal {
  message: string;
  /** The refusal is about the plan, so the page offers an Upgrade button beside it. */
  upgrade: boolean;
}

/** The server's own words when it refused a connect on purpose, so the page shows them instead of a generic failure. */
export function connectRefusal(result: AuthorizeResult): ConnectRefusal | null {
  if (result.refused !== true || !result.error) return null;
  return { message: result.error, upgrade: result.refusalKind === 'premium_only' };
}
